// Lipemwear Wishlist - localStorage-powered, auto-injects into Atelier theme
(function () {
  'use strict';

  var STORAGE_KEY = 'lipemwear_wishlist';

  // ── Storage ──────────────────────────────────────────────────────────────
  function getList() {
    try { return JSON.parse(localStorage.getItem(STORAGE_KEY) || '[]'); }
    catch (e) { return []; }
  }
  function saveList(list) {
    try { localStorage.setItem(STORAGE_KEY, JSON.stringify(list)); }
    catch (e) {}
  }
  function isWishlisted(id) { return getList().indexOf(String(id)) !== -1; }

  function toggle(id, title) {
    var list = getList();
    var sid = String(id);
    var idx = list.indexOf(sid);
    var added;
    if (idx === -1) { list.push(sid); added = true; }
    else { list.splice(idx, 1); added = false; }
    saveList(list);
    refreshButtons(id);
    refreshCounts();
    toast(added ? 'Added to wishlist ♥' : 'Removed from wishlist');
    return added;
  }

  // ── SVG hearts ───────────────────────────────────────────────────────────
  var HEART_FILLED = '<svg viewBox="0 0 24 24" fill="#C9A96E" width="18" height="18" xmlns="http://www.w3.org/2000/svg"><path d="M12 21.35l-1.45-1.32C5.4 15.36 2 12.28 2 8.5 2 5.42 4.42 3 7.5 3c1.74 0 3.41.81 4.5 2.09C13.09 3.81 14.76 3 16.5 3 19.58 3 22 5.42 22 8.5c0 3.78-3.4 6.86-8.55 11.54L12 21.35z"/></svg>';
  var HEART_EMPTY = '<svg viewBox="0 0 24 24" fill="none" stroke="#F2EDD8" stroke-width="1.5" width="18" height="18" xmlns="http://www.w3.org/2000/svg"><path d="M12 21.35l-1.45-1.32C5.4 15.36 2 12.28 2 8.5 2 5.42 4.42 3 7.5 3c1.74 0 3.41.81 4.5 2.09C13.09 3.81 14.76 3 16.5 3 19.58 3 22 5.42 22 8.5c0 3.78-3.4 6.86-8.55 11.54L12 21.35z"/></svg>';

  // ── Buttons ───────────────────────────────────────────────────────────────
  function makeButton(id, title) {
    var btn = document.createElement('button');
    btn.className = 'lw-wish-btn' + (isWishlisted(id) ? ' lw-wish-btn--on' : '');
    btn.setAttribute('aria-label', 'Wishlist');
    btn.setAttribute('data-lw-id', String(id));
    btn.setAttribute('type', 'button');
    btn.innerHTML = isWishlisted(id) ? HEART_FILLED : HEART_EMPTY;
    btn.addEventListener('click', function (e) {
      e.preventDefault();
      e.stopPropagation();
      var added = toggle(id, title);
      btn.innerHTML = added ? HEART_FILLED : HEART_EMPTY;
      btn.classList.toggle('lw-wish-btn--on', added);
    });
    return btn;
  }

  function refreshButtons(id) {
    var active = isWishlisted(id);
    document.querySelectorAll('[data-lw-id="' + id + '"]').forEach(function (btn) {
      btn.innerHTML = active ? HEART_FILLED : HEART_EMPTY;
      btn.classList.toggle('lw-wish-btn--on', active);
    });
  }

  function refreshCounts() {
    var n = getList().length;
    document.querySelectorAll('.lw-wish-count').forEach(function (el) {
      el.textContent = n;
      el.style.display = n > 0 ? 'flex' : 'none';
    });
  }

  // ── Inject into product cards ─────────────────────────────────────────────
  var injected = new Set();

  function injectCards() {
    // Atelier renders product cards as <product-card> custom elements or
    // <li> / <article> elements with data-product-id attributes
    var candidates = document.querySelectorAll('product-card, [data-product-id], .product-card');
    candidates.forEach(function (card) {
      var id = card.getAttribute('data-product-id') || card.dataset.productId;
      if (!id || injected.has(card)) return;

      var title = card.getAttribute('data-product-title') || '';
      if (!title) {
        var a = card.querySelector('a[href*="/products/"]');
        if (a) title = a.getAttribute('aria-label') || a.textContent.trim() || '';
      }

      // Find the media container for button placement
      var media = card.querySelector('.product-card__media, .media, .image, figure, [class*="-media"]');
      var target = media || card;
      if (target !== card) target.style.position = target.style.position || 'relative';

      var btn = makeButton(id, title);
      target.appendChild(btn);
      injected.add(card);
    });
  }

  // ── Header wishlist icon ──────────────────────────────────────────────────
  function injectHeaderIcon() {
    if (document.querySelector('.lw-header-wish')) return;

    var iconBar = document.querySelector('.header__icons, .header__icon-list, [class*="header__action"]');
    if (!iconBar) return;

    var a = document.createElement('a');
    a.href = '/pages/wishlist';
    a.className = 'lw-header-wish header__icon';
    a.setAttribute('aria-label', 'Wishlist');
    a.innerHTML =
      '<svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.5" width="22" height="22">' +
      '<path d="M12 21.35l-1.45-1.32C5.4 15.36 2 12.28 2 8.5 2 5.42 4.42 3 7.5 3c1.74 0 3.41.81 4.5 2.09C13.09 3.81 14.76 3 16.5 3 19.58 3 22 5.42 22 8.5c0 3.78-3.4 6.86-8.55 11.54L12 21.35z"/>' +
      '</svg>' +
      '<span class="lw-wish-count" style="display:none" aria-label="Wishlist items">0</span>';

    // Insert before the first child (before cart icon)
    iconBar.insertBefore(a, iconBar.firstChild);
    refreshCounts();
  }

  // ── Toast ─────────────────────────────────────────────────────────────────
  var toastEl;
  var toastTimer;
  function toast(msg) {
    if (!toastEl) {
      toastEl = document.createElement('div');
      toastEl.id = 'lw-toast';
      document.body.appendChild(toastEl);
    }
    toastEl.textContent = msg;
    toastEl.classList.add('lw-toast--show');
    clearTimeout(toastTimer);
    toastTimer = setTimeout(function () {
      toastEl.classList.remove('lw-toast--show');
    }, 2200);
  }

  // ── Wishlist page rendering ───────────────────────────────────────────────
  function renderWishlistPage() {
    var container = document.getElementById('lw-wishlist-page');
    if (!container) return;

    var ids = getList();
    if (ids.length === 0) {
      container.innerHTML =
        '<p style="text-align:center;padding:80px 0;color:#F2EDD8;font-size:14px;letter-spacing:.05em;text-transform:uppercase;">' +
        'Your wishlist is empty — <a href="/collections/all" style="color:#C9A96E;">browse the collection</a>.' +
        '</p>';
      return;
    }

    container.innerHTML = '<p style="text-align:center;padding:40px 0;color:#C9A96E;font-size:12px;letter-spacing:.1em;text-transform:uppercase;">Loading your wishlist&hellip;</p>';

    var promises = ids.map(function (id) {
      return fetch('/products.json?ids=' + id + '&limit=1')
        .then(function (r) { return r.json(); })
        .then(function (d) { return d.products && d.products[0]; })
        .catch(function () { return null; });
    });

    Promise.all(promises).then(function (products) {
      var valid = products.filter(Boolean);
      if (!valid.length) {
        container.innerHTML = '<p style="text-align:center;padding:80px 0;color:#F2EDD8;">Your wishlist is empty.</p>';
        return;
      }
      container.innerHTML =
        '<div class="lw-wish-grid">' +
        valid.map(function (p) {
          var price = p.variants && p.variants[0] ? (p.variants[0].price / 100).toFixed(2) : '—';
          var img = p.images && p.images[0] ? p.images[0].src : '';
          return (
            '<div class="lw-wish-item">' +
            '<a class="lw-wish-item__img" href="/products/' + p.handle + '">' +
            (img ? '<img src="' + img + '" alt="' + p.title.replace(/"/g, '&quot;') + '" loading="lazy">' : '') +
            '</a>' +
            '<div class="lw-wish-item__body">' +
            '<a href="/products/' + p.handle + '"><p class="lw-wish-item__title">' + p.title + '</p></a>' +
            '<p class="lw-wish-item__price">$' + price + '</p>' +
            '<div class="lw-wish-item__actions">' +
            '<a href="/products/' + p.handle + '" class="button button--primary">View Product</a>' +
            '<button class="lw-wish-remove" onclick="LipemWishlist.toggle(' + p.id + ')">Remove</button>' +
            '</div></div></div>'
          );
        }).join('') +
        '</div>';

      // Re-inject remove button listeners after render
      injected.clear();
    });
  }

  // ── Styles (injected once) ────────────────────────────────────────────────
  function injectStyles() {
    if (document.getElementById('lw-styles')) return;
    var s = document.createElement('style');
    s.id = 'lw-styles';
    s.textContent = [
      '.lw-wish-btn{position:absolute;top:10px;right:10px;z-index:10;width:34px;height:34px;border-radius:50%;',
      'background:rgba(10,10,10,.72);border:1px solid rgba(242,237,216,.18);',
      'display:flex;align-items:center;justify-content:center;cursor:pointer;',
      'transition:background .2s,transform .15s;padding:0;backdrop-filter:blur(6px);}',
      '.lw-wish-btn:hover{background:rgba(201,169,110,.35);transform:scale(1.12);}',
      '.lw-wish-btn--on{background:rgba(201,169,110,.2);}',
      '.lw-wish-btn svg{display:block;pointer-events:none;}',
      '.lw-header-wish{position:relative;display:inline-flex;align-items:center;margin-inline-end:4px;}',
      '.lw-wish-count{position:absolute;top:-7px;right:-7px;background:#C9A96E;color:#0A0A0A;',
      'font-size:9px;width:16px;height:16px;border-radius:50%;display:flex;align-items:center;',
      'justify-content:center;font-weight:700;line-height:1;}',
      '#lw-toast{position:fixed;bottom:80px;left:50%;transform:translateX(-50%) translateY(16px);',
      'background:#111;color:#F2EDD8;border:1px solid #C9A96E;padding:10px 24px;',
      'font-size:12px;letter-spacing:.08em;text-transform:uppercase;opacity:0;',
      'transition:opacity .3s,transform .3s;pointer-events:none;z-index:9999;white-space:nowrap;}',
      '#lw-toast.lw-toast--show{opacity:1;transform:translateX(-50%) translateY(0);}',
      '.lw-wish-grid{display:grid;grid-template-columns:repeat(auto-fill,minmax(260px,1fr));gap:28px;padding:40px 0;}',
      '.lw-wish-item__img img{width:100%;aspect-ratio:3/4;object-fit:cover;display:block;}',
      '.lw-wish-item__body{padding:12px 0;}',
      '.lw-wish-item__title{font-size:13px;text-transform:uppercase;letter-spacing:.05em;margin:0 0 4px;color:#F2EDD8;}',
      '.lw-wish-item__price{font-size:14px;color:#C9A96E;margin:0 0 14px;}',
      '.lw-wish-item__actions{display:flex;gap:10px;align-items:center;flex-wrap:wrap;}',
      '.lw-wish-remove{background:transparent;border:1px solid rgba(242,237,216,.3);color:#F2EDD8;',
      'font-size:11px;letter-spacing:.08em;text-transform:uppercase;padding:8px 16px;cursor:pointer;',
      'transition:border-color .2s,color .2s;}',
      '.lw-wish-remove:hover{border-color:#C9A96E;color:#C9A96E;}'
    ].join('');
    document.head.appendChild(s);
  }

  // ── Observer for dynamic content ──────────────────────────────────────────
  var observer = new MutationObserver(function () { injectCards(); });

  // ── Init ──────────────────────────────────────────────────────────────────
  function init() {
    injectStyles();
    injectCards();
    injectHeaderIcon();
    refreshCounts();
    renderWishlistPage();

    observer.observe(document.body, { childList: true, subtree: true });

    document.addEventListener('shopify:section:load', function () {
      injected.clear();
      injectCards();
      injectHeaderIcon();
      refreshCounts();
    });
  }

  // Public API
  window.LipemWishlist = { toggle: toggle, getList: getList, isWishlisted: isWishlisted };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
